import { render, staticRenderFns } from "./g-video.vue?vue&type=template&id=2611be5a&scoped=true&"
import script from "./g-video.vue?vue&type=script&lang=ts&"
export * from "./g-video.vue?vue&type=script&lang=ts&"
import style0 from "./g-video.vue?vue&type=style&index=0&id=2611be5a&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2611be5a",
  null
  
)

export default component.exports